// extracted by mini-css-extract-plugin
export default {"shopMiddleProfileContainer":"shopProfile_shopMiddleProfileContainer__ZIaK7","socialMediaIcon":"shopProfile_socialMediaIcon__TtDS6"};